














import { Vue } from "vue-property-decorator";
import AppLayout from "@/components/app-layout.vue";
import schemalock from "@/components/schemalock.vue";
import { mapGetters } from 'vuex';
import { Etablissement } from '../../models/Etablissement';
import store from "@/store";
import router from "@/router/";

export default Vue.extend({
components : {AppLayout,schemalock},

computed : {
  ...mapGetters("etablissements", [
      "getCurrentEtablissement"
    ])
},
})
